module.exports = __webpack_public_path__ + "img/DoneMark.ddfc2877.png";